module.exports = __webpack_public_path__ + "zeebra-background-light.a408fd8cc36d9e73aa38.jpg";


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/assets/img/zeebra-background-light.jpg
// module id = ../../../../../src/assets/img/zeebra-background-light.jpg
// module chunks = styles